import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  width: 100%;
  height: ${props => (props.hasImage ? 'auto' : '335px')};
  margin: 0 auto;
  position: relative;
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: ${props => props.primaryColor || '#36397A'};
  overflow: hidden;

  > div {
    width: 100%;
    height: auto;
    
    img {
      width: 100%;
      height: auto;
      display: block;
      max-height: 650px;
    }
  }

  @media only screen and (max-width: 950px) {
    gap: 61px;
    height: ${props => (props.hasImage ? 'unset' : '125px')};;
  }

  a {
    background: ${props => props.primaryColor || '#36397A'};
    width: 224px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    cursor: pointer;
    :hover {
      background: ${props => darken(0.1, props.primaryColor || '#36397A')};
    }
    color: #fff;
    z-index: 1;
  }
`;

export const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  z-index: 1;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
  }
`;

export const SubTitle = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  z-index: 1;

  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
  }
`;

export const TitleContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 1;
  width: 100%;
  height: 100%!important;
  top: 0;
  left: 0;
`;